import React from 'react';
import Transactions from '.';

const WithdrawTransactions = () => (
  <>
    <Transactions
      title="Withdraw Transactions"
      transactionType="WITHDRAW"
    />
  </>
);

export default WithdrawTransactions;
